import {
  Component,
  OnInit,
  input,
  viewChild,
  output
} from "@angular/core";
import {
  IMetadata,
  ISelectOption,
} from "../../../../../core-ui/models/interfaces";
import { NgForm } from "@angular/forms";
import { markFormFields } from "../../../../../app/app.utils";

@Component({
  selector: "av-metadata-builder-pair",
  templateUrl: "./pair.component.html",
  styleUrls: ["./pair.component.scss"],
  standalone: false,
})
export class MetadataBuilderPairComponent implements OnInit {
  readonly item = input<IMetadata<any>>(undefined);
  readonly types = input<ISelectOption[]>(undefined);

  readonly keyLabel = input("Key");
  readonly valueLabel = input("Value");

  readonly updated = output<IMetadata<any>>();
  readonly removed = output<IMetadata<any>>();

  readonly formRef = viewChild<NgForm>("f");

  hasType = false;

  ngOnInit(): void {
    this.hasType = this.types()?.length > 0;
  }

  update() {
    this.updated.emit(this.item());
  }

  remove() {
    this.removed.emit(this.item());
  }

  get valid() {
    // markFormFields(this.formRef.form);
    return this.formRef().valid;
  }
}
